import Button from '@components/Button';
import { reset } from '@features/Checkout/store';
import { useTranslation } from 'next-i18next';
import { useDispatch } from 'react-redux';

import { Root } from './StartOverButton.module.css';

const StartOverButton = () => {
  const { t } = useTranslation(['account', 'common', 'checkout']);
  const dispatch = useDispatch();
  const restartCheckout = () => {
    // eslint-disable-next-line no-alert
    dispatch(
      reset({
        isLoading: true,
      })
    );
  };

  return (
    <Button
      className={Root}
      appearance="text"
      onClick={() => restartCheckout()}
    >
      {t('startOver', { ns: 'checkout' })}
    </Button>
  );
};

export default StartOverButton;
